import React from 'react'
import Nav from './Nav'
import './../styles/Header.css'

function Header(props) {
  const { resetHandler, saveHandler, uploadHandler, downloadHandler } = props

  return (
    <header>
      <div className="container">
        <h1>IMG BOARD</h1>
        <Nav
          resetHandler={resetHandler}
          saveHandler={saveHandler}
          uploadHandler={uploadHandler}
          downloadHandler={downloadHandler}
        />
      </div>
    </header>
  )
}

export default Header
